'use client'

import { useEffect } from 'react'
import { useRouter } from 'next/navigation'

export default function NotFound() {
    const router = useRouter()

    useEffect(() => {
        router.replace('/auth/login')
    }, [router])

    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-100">
            <p className="text-slate-500">正在跳转到登录页面...</p>
        </div>
    )
}
